import { render, staticRenderFns } from "./WeTransportEquipmentV2Block.vue?vue&type=template&id=60153676&scoped=true&"
import script from "./WeTransportEquipmentV2Block.vue?vue&type=script&lang=js&"
export * from "./WeTransportEquipmentV2Block.vue?vue&type=script&lang=js&"
import style0 from "./WeTransportEquipmentV2Block.vue?vue&type=style&index=0&id=60153676&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60153676",
  null
  
)

export default component.exports